<template>
  <div class="base-circular-loading-bar" :class="[color]">
    <div class="base-circular-loading-bar__content">
      <v-progress-circular :size="size" :width="width" indeterminate />
      <div class="base-circular-loading-bar__text" v-if="text">{{ text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseCircularLoadingBar',
  props: {
    size: {
      type: Number,
      default: 50,
    },
    text: {
      type: String,
      default: null,
    },
    width: {
      type: Number,
      default: 4,
    },
    color: {
      type: String,
    },
  },
};
</script>

<style lang="scss">
.base-circular-loading-bar {
  display: flex;
  align-self: center;
  height: 100%;
  justify-content: center;

  &__content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1rem;
  }

  &__text {
    color: $color-neutral;
    margin-top: 1rem;
  }

  .v-progress-circular {
    display: flex;
    justify-self: center;
    margin: 0 auto;
  }
  .v-progress-circular__overlay {
    stroke: $color-normal;
  }

  &.accent {
    .v-progress-circular__overlay {
      stroke: $color-accent;
    }
  }
}
</style>
